

import React from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import AboutUs from './Components/About_us/AboutUs';
import Homepage from './Components/Homepage/Homepage';
import ContactUs from './Components/ContactUs/ContactUs';
import Clients from './Components/Clients/Clients';
import Careers from './Components/Career/Careers'

import NotFound from './Components/NotFound/NotFound';
import Jobs from './Components/Jobs/Jobs';
import 'bootstrap/dist/css/bootstrap.min.css';

const App = () => {
  return (
    <>
     <Router>
      <Routes>
        <Route path="/" element={<Homepage />} />
        <Route path="/about" element={<AboutUs />} />
        <Route path="/contact" element={<ContactUs />} />
        <Route path="/clients" element={<Clients />} />
        <Route path="/careers" element={<Careers />} />
        <Route path="/jobs" element={<Jobs />} />
        <Route path="*" element={<NotFound />} /> {/* Fallback Route */}
      </Routes>
    </Router>
    </>
   
  );
};

export default App;
